import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';

export interface EmspBoLocationNameFilterStateControllerProps {
  value: string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoLocationNameFilterStateController = ({
  value,
  onRemove,
}: EmspBoLocationNameFilterStateControllerProps): React.JSX.Element => (
  <FilteredItem icon="location" label={value} onRemove={onRemove} />
);
